<!-- 添加地址组件 -->
<template>
  <div>
    <div class="form-main">
      <el-form :model="formData" :rules="rules" ref="formData" label-width="110px" class="formData">
        <el-form-item label="联系人" prop="Contactor">
          <el-input v-model.trim="formData.Contactor" v-filter-special-char="formData.Contactor"></el-input>
        </el-form-item>
        <el-form-item label="电话号码" prop="PhoneNum">
          <el-input v-model.trim="formData.PhoneNum" v-filter-special-char="formData.PhoneNum"></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="Tags">
          <el-input v-model.trim="formData.Tags" v-filter-special-char="formData.Tags"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <Region @getRegion="getRegion" :areaSelect="areaSelect"></Region>
        </el-form-item>
        <el-form-item label="详细地址" prop="Addr">
          <el-input v-model.trim="formData.Addr" v-filter-special-char="formData.Addr"></el-input>
        </el-form-item>
        <el-form-item label="设为默认地址" prop="IsDefault" v-if="!originalIsDefault">
          <el-checkbox v-model="formData.IsDefault"></el-checkbox>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-primary" @click="submitForm">提交</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Region from "@/components/common/address.vue";
export default {
  name: "",
  props: ["submitType", "addrData", "areaSelect"],
  components: {
    Region
  },
  data() {
    let checkPhone = this.$util.checkPhone;
    return {
      originalIsDefault: false,
      area: [],
      booleanTrue: true,
      booleanFalse: false,
      formData: {
        EntpId: "",
        PhoneNum: "",
        Contactor: "",
        Tags: "",
        Province: "",
        City: "",
        District: "",
        Addr: "",
        IsDefault: false,
        IsDel: false
      },
      rules: {
        PhoneNum: [{ required: true, validator: checkPhone, trigger: "blur" }],
        Contactor: [
          { required: true, message: "此项必填", trigger: "blur" },
          { max: 50, message: "长度不超过50个字符", trigger: "blur" }
        ],
        Tags: [{ required: true, message: "此项必填", trigger: "blur" }],
        City: [{ required: true, message: "此项必填", trigger: "change" }],
        Addr: [
          { required: true, message: "此项必填", trigger: "blur" },
          { max: 50, message: "长度不超过50个字符", trigger: "blur" }
        ],
        IsDefault: [{ required: true, message: "此项必填", trigger: "blur" }]
      }
    };
  },
  mounted() {
    if (this.submitType == 2) {
      this.formData = { ...this.addrData };
      this.area = [...this.areaSelect];
      this.originalIsDefault = this.addrData.IsDefault;
    }
  },
  watch: {
    addrData() {
      if (this.submitType == 2) {
        this.formData = { ...this.addrData };
        this.area = [...this.areaSelect];
        this.originalIsDefault = this.addrData.IsDefault;
      } else {
        this.formData = {
          EntpId: "",
          PhoneNum: "",
          Contactor: "",
          Tags: "",
          Province: "",
          City: "",
          District: "",
          Addr: "",
          IsDefault: false,
          IsDel: false
        };
        this.area = [];
      }
    }
  },
  methods: {
    getRegion(value) {
      this.area = value;
    },
    // 重置表单
    resetForm() {
      this.$util.clearValidate(this, "formData");
      this.formData = {
        EntpId: "",
        PhoneNum: "",
        Contactor: "",
        Tags: "",
        Province: "",
        City: "",
        District: "",
        Addr: "",
        IsDefault: false,
        IsDel: false
      };
      // this.area=[]
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit("resetData");
    },
    // 提交数据
    submitForm() {
      let _url = "/api/EntpInfoManagement/EditAddress";
      let formName = "formData";
      this.$refs[formName].validate(valid => {
        if (valid) {
          let _formData = this.formData;
          let userMsg = this.$util.getLocalStorage("userMsg");
          _formData.EntpId = userMsg.EntpId;
          _formData.Uid=userMsg.EmployeeId;
          _formData.Province = this.area[0];
          _formData.City = this.area[1];
          _formData.District = this.area[2];
          this.$util
            .axiosPost({
              url: _url,
              data: this.formData
            })
            .then(res => {
              this.formData.Id = res.data;
              this.$util.successMsg("操作成功");
              this.dialogVisible = false;
              this.$emit("loadData", this.submitType, this.formData);
              this.formData = {
                EntpId: "",
                PhoneNum: "",
                Contactor: "",
                Tags: "",
                Province: "",
                City: "",
                District: "",
                Addr: "",
                IsDefault: false,
                IsDel: false
              };
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-footer {
  text-align: right;
}
</style>
<style lang="less">
.add-address-dlg {
  .el-form-item__label::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
.area-select .area-selected-trigger {
  padding: 0 20px;
  line-height: 30px;
}
.area-select-wrap .area-select {
  margin-left: 0px !important;
  margin-right: 10px;
}
</style>
